import i18n from 'i18next';

import { environment } from 'environments/environment';

import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import dayjs from 'helpers/dayjs';

const parseExceptionParams = (value?: string | Record<string, string>): string | undefined => {
  if (value && typeof value !== 'string') {
    return Object.keys(value)
      .map((key) => `${key}=${value[key]}`)
      .join(';');
  } else if (value) {
    return value;
  }

  return undefined;
};

export const api = {
  getInfoMessages: (
    url: string,
    infoMessageIds?: string,
    exceptionParamMaps?: string | Record<string, string>
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/kahl`, {
      params: {
        infoMessageIds: infoMessageIds,
        exceptionParamMaps: parseExceptionParams(exceptionParamMaps),
        timestamp: dayjs().format('YYYY-MM-DDTHH:mm:ss.SSS'),
        sourceApplication: 'ONECRM',
        locale: i18n.language || environment.appTranslation.defaultLocale,
      },
    }),
};
